import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.split";

/**
 * 参考答案展示工具（后台管理端副本，仅用于展示，不参与判分）
 *
 * 与 wxapp 端 src/wxapp/common/utils/referenceAnswer.js 逻辑保持一致；
 * 按仓库跨端约定复制一份，禁止 admin 直接 import wxapp 代码。
 *
 * 规则：
 * 1) 每个 [...] 取第一个备选、去掉方括号，其余字符原样保留；
 * 2) 不含 "[" 的文本原样返回；
 * 3) "[" 未闭合等脏数据整体原样返回，不抛错。
 */
export function formatReferenceAnswer(text) {
  if (text === null || text === undefined) return '';
  var raw = String(text);
  if (raw.indexOf('[') === -1) return raw;
  var result = '';
  var cursor = 0;

  while (cursor < raw.length) {
    var open = raw.indexOf('[', cursor);

    if (open === -1) {
      result += raw.slice(cursor);
      break;
    }

    var close = raw.indexOf(']', open + 1);

    if (close === -1) {
      return raw;
    }

    result += raw.slice(cursor, open);
    result += raw.slice(open + 1, close).split('|')[0];
    cursor = close + 1;
  }

  return result;
}
export default formatReferenceAnswer;